export class DataStore<TData> {
  constructor(private _data: TData) {}

  getData = () => this._data;
  updateData = (data: Partial<TData>) => {
    this._data = {
      ...this._data,
      ...data,
    };
  };
  setData = (data: TData) => {
    this._data = data;
  };
}
